const INSUMOS_API_BASE_URL =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_INSUMOS_API_URL) ||
  "https://4n62aspw9a.execute-api.us-east-1.amazonaws.com";

async function requestInsumos(path, options = {}) {
  const url = `${INSUMOS_API_BASE_URL}${path}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  const text = await response.text();
  const data = text ? JSON.parse(text) : null;

  if (!response.ok) {
    const message = data?.error || data?.message || `Error HTTP ${response.status}`;
    throw new Error(message);
  }

  return data;
}

export function getInsumosApiBaseUrl() {
  return INSUMOS_API_BASE_URL;
}

export function getRequisicionActual() {
  return requestInsumos("/insumos/requisicion-actual");
}

export function saveStockCapturas(payload) {
  return requestInsumos("/insumos/stock-capturas", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function createRequisicionAutomatica() {
  return requestInsumos("/insumos/requisiciones", {
    method: "POST",
  });
}

export function getRequisicionById(requisicionId) {
  return requestInsumos(`/insumos/requisiciones/${encodeURIComponent(requisicionId)}`);
}
